import { Stack, Typography } from '@mui/material'

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { CORAL_600, GRAY_700 } from 'constants/styling/theme'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  /** List of i18n feature keys to render */
  features: string[]
  /** Text size: sm for plan cards, md for plan summary */
  size?: 'sm' | 'md'
}

export const PlanFeatureList: FC<Props> = ({ features, size = 'sm' }) => {
  const { t } = useTranslation(['pricing_page'])

  return (
    <>
      {features.map((featureKey) => (
        <Stack key={featureKey} direction="row" alignItems="flex-start" gap="0.8rem">
          <CheckCircleOutlineIcon sx={{ color: CORAL_600, fontSize: '1.8rem', flexShrink: 0, mt: '0.1rem' }} />
          <Typography variant={size === 'sm' ? 'text-sm' : 'text-md'} fontWeight={350} color={GRAY_700}>
            {t(featureKey)}
          </Typography>
        </Stack>
      ))}
    </>
  )
}
